// returns an object with fixation options set to true, e.g. {ITI: true, allTrial: true}
// {
// 	ITI:,
// 	ISI:,
// 	allTrial:,
// 	withStim:
// }
// only true value are included
function initFixation(fixationValue, fixationStimValue) {
	var fixationValue = computeFixationValue(fixationValue, fixationStimValue);
	var fixationsValues = parseFixation(fixationValue);
	var fixations = {};

	fixationsValues.forEach(function(fixationName) {
		fixations[fixationName] = true;
	})

	return fixations;

	//private functions
	function parseFixation(fixationValue) {
		var fixations = [];

		if (!fixationValue || fixationValue === 'na') {
			return fixations;
		}

		fixations = fixationValue.split(';');

		//curate the values
		var hasAllTrial = fixations.indexOf('allTrial') >= 0;
		var hasAllStim = fixations.indexOf('allStim') >= 0;

		//ignore ISI, withStim if allTrial is present
		var fixationValidValues = !hasAllTrial ? !hasAllStim ? ['ITI', 'ISI', 'withStim'] : ['ITI', 'allStim'] : ['ITI', 'allTrial'];
		fixations = fixations.filter(function(value) {
			return fixationValidValues.indexOf(value) >= 0;
		});

		return fixations;
	}

	// legacy to support fixationStim
	function computeFixationValue(fixationValue, fixationStimValue) {
		if (fixationValue == '1') {
			fixationValue = 'ITI';
		}

		if (fixationStimValue && fixationStimValue !== 'na') {
			fixationValue = fixationValue === 'na' ? 'withStim' : fixationValue + ';withStim';
		}

		return fixationValue;
	}
}

function showFixationITI(trialRow) {
	if (listTrialFixation[trialRow].ITI) {
		showFixation(trialRow);
	}
}

function showTrialFixationAllStimOrTrial(trialRow) {
	if (listTrialFixation[trialRow].allStim || listTrialFixation[trialRow].allTrial) {
		showFixation(trialRow);
	}
}

function hideFixationForScreen(trialRow) {
	if (listTrialFixation[trialRow].allStim || listTrialFixation[trialRow].allTrial || listTrialFixation[trialRow].withStim) {
		return;
	}
	hideFixation();
}

function hideFixationForISI(trialRow) {
	if (listTrialFixation[trialRow].allStim || listTrialFixation[trialRow].allTrial || !listTrialFixation[trialRow].ISI) {
		return;
	}
	hideFixation();
}

function hideFixationAfterLastStim(trialRow) {
	if (listTrialFixation[trialRow].allTrial) {
		return;
	}
	if(listTrialFixation[trialRow].withStim || listTrialFixation[trialRow].allStim){
		hideFixation();
	}
}

function showTrialFixationISIForScreen(trialRow) {
	if (listTrialFixation[trialRow].ISI) {
		showFixation(trialRow);
	}
}

function showTrialFixationForScreen(trialRow) {
	if (listTrialFixation[trialRow].allStim || listTrialFixation[trialRow].allTrial) {
		return;
	}

	if (listTrialFixation[trialRow].withStim) {
		showFixation(trialRow);
	}
}


function showFixation(trialRow)
{
	if (columnForTrial('type', trialRow) != "instructions") {
		var cross = $('#cross');

		//position only once
		if (!showFixation.isPositioned) {
			var container = $('#displayScreen');
			var crossHeight = Math.ceil(cross.height() / 2),
			crossWidth	= Math.ceil(cross.width() / 2);

			cross.css({
				top: Math.ceil(container.height() / 2 - crossHeight),
				left: Math.ceil(container.width() / 2 - crossWidth),
			});

			showFixation.isPositioned = true;
		}

		cross.show();
	}
}

function hideFixation() {
	$('#cross').hide();
}